module.exports = __webpack_public_path__ + "img/rocket-disabled.0626ad5a.svg";